import { isAxiosError, type AxiosError } from "axios";
import { z } from "zod";

export const isAccessDeniedCauseError = (error: unknown): error is AxiosError<AccessDeniedResponse> =>
  isAxiosError(error) &&
  error.response?.status === 403 &&
  accessDeniedResponseSchema.safeParse(error.response.data).success;

// TODO: the rest of the owl
const accessDeniedCauseSchema = z.object({
  code: z.string(),
  // ...
});

export type AccessDeniedCause = z.infer<typeof accessDeniedCauseSchema>;

const accessDeniedResponseSchema = z.object({
  cause: accessDeniedCauseSchema,
});

export type AccessDeniedResponse = z.infer<typeof accessDeniedResponseSchema>;
